export const COCKPIT_SECTION_GROUPS = ["Read the market", "Record and decide"] as const;

export type CockpitSectionGroup = (typeof COCKPIT_SECTION_GROUPS)[number];

export const COCKPIT_SECTIONS = [
  {
    sectionId: "brief-section",
    headingId: "brief-heading",
    label: "Market Brief",
    icon: "insights",
    group: "Read the market",
    description: "Your read of the month for this resin family, what moved since last month, and how the team sees it.",
  },
  {
    sectionId: "nominations-section",
    headingId: "nominations-heading",
    label: "Who Has Announced?",
    icon: "campaign",
    group: "Read the market",
    description: "Each tracked supplier's nomination for the month, and how your call compares with what they're asking.",
  },
  {
    sectionId: "prices-section",
    headingId: "prices-heading",
    label: "Prices in Context",
    icon: "show_chart",
    group: "Read the market",
    description: "Your monthly calls and forecast next to every price the team has logged. Click a point to open it.",
  },
  {
    sectionId: "intelligence-section",
    headingId: "intelligence-heading",
    label: "Market Intelligence",
    icon: "newspaper",
    group: "Read the market",
    description: "Headlines, publisher expectations and consultant notes logged for the month.",
  },
  {
    sectionId: "log-section",
    headingId: "log-heading",
    label: "Log Intelligence",
    icon: "edit_note",
    group: "Record and decide",
    description:
      "Add what you've heard this month. Who Has Announced?, Prices in Context and Market Intelligence all read from here.",
  },
  {
    sectionId: "call-section",
    headingId: "call-heading",
    label: "Make the Call",
    icon: "price_check",
    group: "Record and decide",
    description:
      "Your price for this month and the next three. Saving attaches everything logged for the month as evidence.",
  },
] as const satisfies readonly {
  sectionId: string;
  headingId: string;
  label: string;
  icon: string;
  group: CockpitSectionGroup;
  description: string;
}[];

export type CockpitSection = (typeof COCKPIT_SECTIONS)[number];
export type CockpitSectionId = CockpitSection["sectionId"];

export function cockpitSection(sectionId: CockpitSectionId): CockpitSection {
  return COCKPIT_SECTIONS.find((section) => section.sectionId === sectionId) ?? COCKPIT_SECTIONS[0];
}
